import React, { useState, useEffect, useRef, } from "react";
import { View, Text, FlatList, TouchableOpacity, ScrollView, TextInput,ActivityIndicator } from "react-native";
import moment from "moment";
import applicationStyles from "../styles/applicationStyles";
import RadioButton from "../common/RadioButton";
import CustomButton from "../common/CustomButton";
import { RangeSlider } from "@sharcoux/slider";
import { downloadStatement, getStatements } from "../api/statementApi";
import { getAllVehiclesListV2, getPoolAccountdetail, } from "../api/apiManager";
import { get, random } from "lodash";
import ModalAlert from "../common/ModalAlert";
import Loader from "../common/Loader";
import ReactPaginate from "react-paginate";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import MobileHeader from "../common/MobileHeader";
import TabHeader from "../common/TabHeader";
import { PERIOD_STATEMENT_TYPE } from "../constant/dataHelper"
import useStyles from "./Statement_Styles";
import CImage from "../common/CImage";
import StatementHelpler from "../SubComponents/statement/Helper";
import CText from "../common/CText";
import DateRangePicker from "../SubComponents/statement/Calender";
import Timer from "../SubComponents/statement/TimerLoader";
import { getConfigurations } from "../api/serviceRequest";
import { StatementAlert, StatementNoPreviewAlert } from "./StatementAlert.web";
import CView from "../common/CView";

const Statement = (props) => {
  const styles = useStyles();
  const [showCalender, setShowCalender] = useState(false)
  const [filterStatementType, filterSetSelectStatementType] = useState("Both");
  const [filterStatementDownloadType, filterSetSelectStatementDownloadType] = useState("CSV");
  const [periodStatementType, periodSetSelectStatementType] = useState("Last 1 Month");
  const [period, setPeriod] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [poolAcntNbr, setPoolAcntNbr] = useState("");
  const [pageNumbers, setPageNumbers] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [items, setItem] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [statementVrnData, setStatementVrnData] = useState({ getVrnStatement: [], });
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [minAmount, setMinAmount] = useState(0);
  const [maxAmount, setMaxAmount] = useState(1000000);
  const [transactionType, setTransactionType] = useState("")
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "", navigateScreen: "", actionButton: "" });
  const dropdownRef = useRef(null);
  const calendarRef = useRef(null)
  const [showLoader, setShowLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showSearchDropdown, setShowSearchDeopdown] = useState(false);
  const [filterCleared, setFilterCleared] = useState(false);
  const [showAlert , setShowAlert] = useState(false);
  const [showAlertNoPreview, setShowAlertNoPreview] = useState(false);  
  const [isGenerating, setIsGenerating] = useState(false);
  const [emailParams, setEmailParams] = useState(null);
  const [emailToSend, setEmailToSend] = useState(null);
  const [showAlertGetMail, setShowAlertGetMail] = useState(false);
  const onCloseModal = () => { setAlertModalVisible(false); };
  const toggleDropdown = () => { setOpen(!isOpen); };
  const handleClickOutside = (event) => { 
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) { setOpen(false); }
    if (calendarRef.current && !calendarRef.current.contains(event.target)) { setShowCalender(false); } 
  };
  const handleValueChange = (val) => {
    setMinAmount(val[0]);
    setMaxAmount(val[1]);
  };
  const [appliedStatementType, setAppliedStatementType] = useState('CONSOLIDATED');

  let statementType;

    if (!selectedItem) {
      statementType = "CONSOLIDATED";
    } else if (selectedItem === "Consolidated") {
      statementType = "CONSOLIDATED";
    } else if (selectedItem === poolAcntNbr) {
      statementType = "POOL";
    } else {
      statementType = "VEHICLE";
    }
  useEffect(() => {
    loadDefaultConfig()
    getPoolAccountDtls();
    getAllVehiclesList();
    fetchRecords("0")
    document.addEventListener("click", handleClickOutside, true);
    return () => { 
      document.removeEventListener("click", handleClickOutside, true);
     };
  }, []);

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setPoolAcntNbr(res?.accountNo || "");
      }).catch((err) => { setLoading(false); });
  };
  const dateValidation = (pageNum) => {
    const date1 = new Date(moment(fromDate).format("MM/DD/YYYY"))
    const date2 = new Date(moment(toDate).format("MM/DD/YYYY"))
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      // === ADD THIS CHECK date validation ===
  if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate), 'day')) {
    setAlertModalVisible(true);
    setAlertModal({ 
      title: "Error", 
      status: "error", 
      message: "End date cannot be less than start date.", 
      navigateScreen: "Statement", 
      actionButton: "OK" 
    });
    setToDate("");
    return;
  }
    if(fromDate && !toDate){
      setAlertModalVisible(true);
      setAlertModal({ title: "Error", status: "error", message: "Please select the valid date range.", navigateScreen: "Statement", actionButton: "OK" });
      setFromDate("")
      return 
    }else if(toDate && !fromDate){
      setAlertModalVisible(true);
      setAlertModal({ title: "Error", status: "error", message: "Please select the valid date range.", navigateScreen: "Statement", actionButton: "OK" });
      setToDate("")
      return 
    }
    
    if (selectedItem == poolAcntNbr || selectedItem == "Consolidated" || selectedItem == "VEHICLE_CONSOLIDATED" || selectedItem == "VEHICLE_SUMMARY") {
      if (items.length > global.MAX_VRN_COUNT_PORTAL_STMT ) {
        if (diffDays > 30) {
          setAlertModalVisible(true);
          setAlertModal({ title: "Error", status: "error", message: "Please select a date range of one month.", navigateScreen: "Statement", actionButton: "OK" });

        } else {
          fetchRecords(pageNum)
        }
      }else{
        fetchRecords(pageNum)
      }
    } else {
      fetchRecords(pageNum)
    }

  }
  const filter = (page) => {
    setLoading(true);
    if (selectedItem == "VEHICLE_SUMMARY") {
      setShowAlertNoPreview("Vehicle Summary");
      setLoading(false);
    }
    else if (selectedItem == "VEHICLE_CONSOLIDATED") {
      setShowAlertNoPreview("All Vehicle");
      setLoading(false);
    }
    let params = {
      userId: global.userCd,
      vrn: selectedItem === poolAcntNbr ? "" : selectedItem && selectedItem === "Consolidated" ? "" : selectedItem,
      statementType: statementType,
      isCreditOrDebit: filterStatementType == "Debit" ? "D" : filterStatementType == "Both" ? "Both" : "C",
      periodOfStmt: period, poolAccountNo: selectedItem === poolAcntNbr ? poolAcntNbr : "",
      customFrom: fromDate, customTo: toDate, priceFrom: minAmount, priceTo: maxAmount, pageNo: page,
      transactionType: transactionType
    };

    getStatements(params)
      .then((res) => {
        setLoading(false);
        setStatementVrnData(() => ({ getVrnStatement: res.transactions, }));
        setAppliedStatementType(statementType);
        let pageNums = [];
        for (var x = 1; x <= res.totalPages; x++) { pageNums.push(x); }
        setPageNumbers(res.totalPages);
        setFilterModalVisible(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const onFilterClear = () => {
    setPeriod(1);
    periodSetSelectStatementType("Last 1 Month");
    filterSetSelectStatementType("Both");
    setMinAmount(0);
    setMaxAmount(1000000);
    setFilterCleared(true); // Set a flag to track when the filter is cleared
  };
  useEffect(() => {
    if (filterCleared) {
      fetchRecords("0");
      setFilterCleared(false); // Reset flag after fetching records
    }
  }, [filterCleared]);
  const handleItemClick = (vrn) => {
    setOpen(false);
    setSelectedItem(vrn);
    setShowSearchDeopdown(false)
  };
  const getDropdownValue = () => {
    return selectedItem && selectedItem != "" && selectedItem != poolAcntNbr && selectedItem != "Consolidated" && selectedItem !="VEHICLE_SUMMARY" && selectedItem !="VEHICLE_CONSOLIDATED" ? items.find((item) => item.vrn === selectedItem).vrn : selectedItem == poolAcntNbr
      ? poolAcntNbr : selectedItem == "Consolidated" ? "Consolidated" : selectedItem == "VEHICLE_SUMMARY" ? "Vehicle Summary" : selectedItem == "VEHICLE_CONSOLIDATED" ? "All Vehicle Statement" : "";
  };
  const getAllVehiclesList = () => {
    getAllVehiclesListV2()
      .then((res) => {
        setItem(res);
      }).catch((err) => { });
  };
  const onClickPagination = (page) => {
    fetchRecords(page)
  };
  const vehicleDropdwon = () => {
    return (
      <View>
        <Text style={{ marginBottom: 5 }}>Select Statement Type</Text>
        <TouchableOpacity
          onPress={toggleDropdown}
          style={isOpen ? styles.dropDownHeader : styles.dropDownHeaderHide}
        >
          <View style={styles.dropDownWrapper}>
            <TextInput
              value={showSearchDropdown ? searchText : getDropdownValue()}
              onChangeText={(t) => {
                setSearchText(t.toUpperCase());
                setShowSearchDeopdown(true);
              }}
              placeholder={"Select or Search Vehicle"}
            />
            <CImage.dropdownArrowBg />
          </View>
        </TouchableOpacity>
  
        <View
          style={isOpen ? styles.showDropdown : applicationStyles.hideDropdown}
          ref={dropdownRef}
        >
          <TouchableOpacity
            onPress={() => handleItemClick("Consolidated")}
            style={applicationStyles.listItems}
          >
            <Text style={applicationStyles.listItem}>
              Consolidated Statement (Pool + Vehicle)
            </Text>
          </TouchableOpacity>
  
          <TouchableOpacity
            onPress={() => handleItemClick("VEHICLE_CONSOLIDATED")}
            style={applicationStyles.listItems}
          >
            <Text style={applicationStyles.listItem}>
              All Vehicle Statement (only CSV)
            </Text>
          </TouchableOpacity>
  
          <TouchableOpacity
            onPress={() => handleItemClick("VEHICLE_SUMMARY")}
            style={applicationStyles.listItems}
          >
            <Text style={applicationStyles.listItem}>
              Vehicle Summary (only CSV)
            </Text>
          </TouchableOpacity>
  
          <TouchableOpacity
            onPress={() => handleItemClick(poolAcntNbr)}
            style={applicationStyles.listItems}
          >
            <Text style={applicationStyles.listItem}>
              Pool Account Statement
            </Text>
          </TouchableOpacity>
  
          {searchText && searchText?.length > 1
            ? items?.map((item, index) =>
                item.vrn.includes(searchText) ? (
                  <TouchableOpacity
                    onPress={() => handleItemClick(item.vrn)}
                    key={index}
                    style={applicationStyles.listItems}
                  >
                    <Text style={applicationStyles.listItem}>
                      {item.vrn}
                    </Text>
                  </TouchableOpacity>
                ) : null
              )
            : items?.map((item, index) => (
                <TouchableOpacity
                  onPress={() => handleItemClick(item.vrn)}
                  key={index}
                  style={applicationStyles.listItems}
                >
                  <Text style={applicationStyles.listItem}>
                    {item.vrn}
                  </Text>
                </TouchableOpacity>
              ))}
        </View>
      </View>
    );
  };
  
  const onResetClick = () => {
    setSearchText("")
    setShowCalender(false)
    setSelectedItem("");
    setStatementVrnData(() => ({ getVrnStatement: [] }));
    setTransactionType("")
    filterSetSelectStatementType("Both")
    filterSetSelectStatementDownloadType("CSV")
    setFromDate("")
    setToDate("")
    setPeriod(1);
    periodSetSelectStatementType("Last 1 Month");
    let params = {
      userId: global.userCd,
      vrn: "",
      statementType: "CONSOLIDATED",
      periodOfStmt: 1, 
      poolAccountNo: "",
      customFrom: "",
      customTo:"",
      priceFrom: 0, 
      priceTo: 1000000,
      pageNo: 0,
      transactionType: ""
    };
    fetchRecords("0",params)
    setShowAlertNoPreview(false)
  }
  const searchbuttonDisabe = () => {
    if (selectedItem != "" || toDate != "" ) { return false } else { return true }
  }
  const showVrnValidation = () =>{
    setAlertModalVisible(true)
    setAlertModal({ title: "Error", status: "error", message: "Please select the vehicle first.", navigateScreen: "Statement", actionButton: "OK" });

  }
  const headerSection = () => {
    return (<>
      <View style={styles.headerContent}>
        <View style={{zIndex:2}}>{vehicleDropdwon()}</View>
        <View style={styles.verticalLine}></View>
         <View style={{zIndex:1}}>
        <Text style = {{marginBottom:5}}>Date Range</Text>
          <TouchableOpacity onPress={() => {
            selectedItem == "" ? 
            showVrnValidation()
            :setShowCalender(!showCalender)
            }}>
            <View style={styles.calenderInput}>
              {fromDate == "" || toDate == "" ?  <Text style={applicationStyles.dropDownHeaderText}>Select Date Range</Text> :
                <Text style={applicationStyles.dropDownHeaderText}>
                  {moment(fromDate).format("YYYY-MM-DD")} - {moment(toDate).format("YYYY-MM-DD")}
                </Text>}
              <CImage.calendar></CImage.calendar>
            </View>
          </TouchableOpacity>
          {showCalender ?
            <View style={styles.calenderWrapper} ref={calendarRef}> 
            {<DateRangePicker
              setToDate={setToDate} setFromDate={setFromDate} className = {styles.calenderWrapper}
              selectedItem={selectedItem} poolAcntNbr={poolAcntNbr}
              setShowCalender={setShowCalender} vehicleLength={items.length}
              setAlertModalVisible={setAlertModalVisible} setAlertModal={setAlertModal}
            />}</View> : null}
        </View>
        <View style={[styles.btnBox, { minWidth: 100, height: 35 }]}>
          <CustomButton onPress={() => {searchbuttonDisabe()? "" :dateValidation("0")}} text={"Search"} disable={searchbuttonDisabe()} />
        </View>
        <TouchableOpacity onPress={() => onResetClick()} style = {{marginTop:20}}><CText.tagWarningText>{"RESET"}</CText.tagWarningText>
        </TouchableOpacity>
      </View>
    </>)
  }
  const fetchRecords = (page,paramObj)=>{
    setLoading(true);
    if (selectedItem == "VEHICLE_SUMMARY") {
      setShowAlertNoPreview("Vehicle Summary");
      setLoading(false);

    }
    else if (selectedItem == "VEHICLE_CONSOLIDATED") {
      setShowAlertNoPreview("All Vehicle");
      setLoading(false);
    }
 
    let params = {
      userId: global.userCd,
      vrn: selectedItem === poolAcntNbr ? "" : selectedItem && selectedItem === "Consolidated" ? "" : selectedItem,
      statementType: statementType,
      isCreditOrDebit: filterStatementType == "Debit" ? "D" : filterStatementType == "Both" ? "Both" : "C",
      periodOfStmt: (toDate == "" || fromDate == "") ? period : "custom", 
      poolAccountNo: selectedItem === poolAcntNbr ? poolAcntNbr : "",
      customFrom: fromDate ? moment(fromDate).format("YYYY-MM-DD") :"",
      customTo: toDate ? moment(toDate).format("YYYY-MM-DD") :"",
      priceFrom: minAmount, 
      priceTo: maxAmount,
      pageNo: page,
      transactionType: transactionType
    };
    if(paramObj){
      params = paramObj
    }

    
    getStatements(params).then(res=>{
      setLoading(false);
      setStatementVrnData(() => ({ getVrnStatement: res.transactions, }));
      setAppliedStatementType(statementType);
      let pageNums = [];
      for (var x = 1; x <= res.totalPages; x++) { pageNums.push(x); }
      setPageNumbers(res.totalPages);
      setFilterModalVisible(false);
    }).catch((err) => { setLoading(false); });
  }

  const handleConfirmEmail = (email) => {
    setEmailToSend(email);
    onDownloadStatementAction("Email", email); // pass email as param
  };
  
    const onDownloadStatementAction = (actionType = "Download", email = null) => {
    // const downloadType = filterStatementDownloadType; // "PDF" or "CSV"
    const downloadType = "CSV"; // "PDF" or "CSV"
    const apiType = actionType === "Email" ? "email" : "download";
  
  const params = {
    userId: global.userCd,
    vrn:
      selectedItem === poolAcntNbr ||
      selectedItem === "Consolidated" ||
      selectedItem === "VEHICLE_SUMMARY" ||
      selectedItem === "VEHICLE_CONSOLIDATED"
        ? ""
        : selectedItem,
  
    statementType:
      selectedItem === "VEHICLE_SUMMARY" || selectedItem === "VEHICLE_CONSOLIDATED"
        ? selectedItem
        : selectedItem == poolAcntNbr
        ? "POOL"
        : selectedItem == "Consolidated"
        ? "CONSOLIDATED"
        : selectedItem && selectedItem !== poolAcntNbr && selectedItem !== "VEHICLE_SUMMARY" && selectedItem !== "VEHICLE_CONSOLIDATED" && selectedItem !== "consolidated"
        ? "VEHICLE"
        : "CONSOLIDATED",
  
    periodOfStmt: fromDate ? "custom" : `${period}`,
    poolAccountNo: selectedItem === poolAcntNbr ? poolAcntNbr : "",
    customFrom: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
    customTo: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    priceFrom: minAmount,
    priceTo: maxAmount,
    pageNo: "0",
    transactionType: transactionType,
    type: apiType,
    downLoadType: downloadType,
  };
  
  
    if (email && apiType === "email") {
      params["emailId"] = email;
    }
  
    // setLoading(true);
    setIsGenerating(true); // 👈 Starts Timer UI
  
  
    downloadStatement(params)
      .then((res) => {
        if (res.statusCode === 750) {
          // 👇 show modal and store current params
          setIsGenerating(false);
          setShowAlertNoPreview(false);
          setEmailParams(params);
          setShowAlertGetMail(true);
          
          return;
        }
        if (apiType === "download") {
    const downloadUrl = res?.data?.encodedStmttFile;
    const fileExt = res?.data?.downLoadType === "PDF" ? ".pdf" : ".zip";
    const timestamp = moment(new Date()).format("DD-MM-YYYY_hh-mm-ssa");
    const fileName = `Statement_${timestamp}${fileExt}`;
  
    if (downloadUrl) {
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  
    setIsGenerating(false);
    setShowAlertNoPreview(false);

  }
  
        if (res.statusCode === 700 ) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res.message,
            navigateScreen: "Statement",
            actionButton: "OK",
          });
        } 
        else if (res.statusCode === 500) {
          setAlertModal({
            title: "Error",
            status: "Failed",
            message: "Request Failed",
            navigateScreen: "Statement",
            actionButton: "OK",
          });
        }else {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setIsGenerating(false); // 👈 Stop Timer UI`
      })
      .finally(() => {
        // setLoading(false);
        setIsGenerating(false)
        setAlertModalVisible(true);
      });
  };
  const loadDefaultConfig = () => {
    getConfigurations().then((res)=>{
      if(res.statusCode == 200) {
        const MAX_VRN_COUNT_PORTAL_STMT  = res?.data.find((configItem) => configItem.key == "MAX_VRN_COUNT_PORTAL_STMT");
          if (MAX_VRN_COUNT_PORTAL_STMT) {
            global.MAX_VRN_COUNT_PORTAL_STMT = MAX_VRN_COUNT_PORTAL_STMT.value;
          }
      }
    }).catch((err)=>{})
}
  return (
    <View >
      <Header />
      <MobileHeader isShowSidebar={setIsShowSidebar} />
      <TabHeader />
      <View style={styles.mainContainer}>
        <View style={styles.contentWidget}>
          {!isShowSidebar && <Sidebar navigation={props.navigation} />}
          <View style={styles.dataTable}>
            {headerSection()}
            <StatementHelpler
              fromDate={fromDate} toDate={toDate}
              selectedItem={selectedItem} poolAcntNbr={poolAcntNbr}
              setAlertModalVisible={setAlertModalVisible} setAlertModal={setAlertModal}
              setLoading={setLoading} period={period}
              setSelectedItem={setSelectedItem}              
              fetchRecords={fetchRecords} setFilterModalVisible={setFilterModalVisible}
              filterSetSelectStatementType={filterSetSelectStatementType} filterStatementType={filterStatementType}
              filterSetSelectStatementDownloadType={filterSetSelectStatementDownloadType} filterSelectStatementDownloadType={filterStatementDownloadType}
              transactionType={transactionType} setTransactionType={setTransactionType} vehicleLength={items.length}
              minAmount={minAmount} maxAmount={maxAmount} setShowLoader = {setShowLoader} showLoader={showLoader}
            />

            {statementVrnData.getVrnStatement?.length > 0 ? (
              <View style={{maxWidth:1080,maxHeight: 550, overflow: "hidden"}}>
              <ScrollView horizontal={true} style={{ zIndex: -1 }}>
                <View style={{ width: "98%", borderRadius: 20 }}>
                  <View style={styles.headerViewStyle}>
                  {/* {selectedItem == "Consolidated" && (<Text style={[styles.headerTextStyle, { width: 145, minWidth: 145 }]}>{"Vehicle Number"}</Text>)}
                    {selectedItem == "Consolidated" && (<View style={styles.verticalLineStyle} />)} */}
                    <Text style={[styles.headerTextStyle, { width: 145, minWidth: 145 }]}>{"Vehicle Number"}</Text>
                   <View style={styles.verticalLineStyle} />
                    <Text style={[styles.headerTextStyle, { width: 130, minWidth: 130 }]} > {"Transaction Date & TIme"} </Text>
                    <View style={styles.verticalLineStyle} />
                    <Text style={[styles.headerTextStyle, { width: 130, minWidth: 130 }]}> {"Value Date & TIme"} </Text>
                    <View style={styles.verticalLineStyle} />
                    <Text style={[styles.headerTextStyle, { width: 185, minWidth: 185 }]}> {"Transaction No."} </Text>
                    <View style={styles.verticalLineStyle} />
                    <Text style={[styles.headerTextStyle, { width: 180, minWidth: 180 }]}> {"Transaction Details"} </Text>
                    <View style={styles.verticalLineStyle} />

                      {appliedStatementType === "CONSOLIDATED" ? (
                          <>
                            <Text style={styles.headerTextStyle}>{"Debit Tag"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={styles.headerTextStyle}>{"Credit Tag"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={styles.headerTextStyle}>{"Debit Pool"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={styles.headerTextStyle}>{"Credit Pool"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={styles.headerTextStyle}>{"Tag Closing Bal"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={[styles.headerTextStyle, { width: 160, minWidth: 150 }]}>{"Pool Closing Bal"}</Text>
                          </>
                        ) : (
                          <>
                            <Text style={styles.headerTextStyle}>{"Debit Amount"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={[styles.headerTextStyle, { width: 100 }]}>{"Credit Amount"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={[styles.headerTextStyle, { width: 130 }]}>{"Balance Amount"}</Text>
                          </>
                        )}
                  </View>
                  <FlatList
                    key={random()}
                    showsVerticalScrollIndicator
                    data={statementVrnData.getVrnStatement}
                    showsHorizontalScrollIndicator
                    keyExtractor={(item, index) => index + "_" + item?.id?.toString()}
                    renderItem={({ item, index }) => {
                      const debit = appliedStatementType === "POOL"
                        ? item.debitPool || "-"
                        : appliedStatementType === "VEHICLE"
                          ? item.debitTag || "-"
                          : "-";
                      const credit = appliedStatementType === "POOL"
                        ? item.creditPool || "-"
                        : appliedStatementType === "VEHICLE"
                          ? item.creditTag || "-"
                          : "-";
                        const tagClosingBal = isNaN(parseFloat(item.closingTagBalance)) ? "-" : parseFloat(item.closingTagBalance);
                        const poolClosingBal = isNaN(parseFloat(item.closingPoolBalance)) ? "-" : parseFloat(item.closingPoolBalance);
                      const balance = appliedStatementType === "CONSOLIDATED"
                        ? null
                        : appliedStatementType === "VEHICLE"
                          ? tagClosingBal
                          : appliedStatementType === "POOL"
                            ? poolClosingBal
                            : null;

                      return (
                        <View style={[styles.dataViewStyle, { backgroundColor: index % 2 !== 0 ? "#ffffff" : "#E5E5E5" }]} >
                          {/* {selectedItem == "Consolidated" && (<Text style={[styles.headerTextStyle, { width: 145, minWidth: 145 }]}> {item.vrn} </Text>)} */}
                          {/* {selectedItem == "Consolidated" && (<View style={styles.verticalLineStyle} />)} */}
                          <Text style={[styles.headerTextStyle, { width: 145, minWidth: 145 }]}> {item.vrn ?? 'N/A'}</Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 130, minWidth: 130 }]}> {item.dateTime} </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 130, minWidth: 130 }]}>{item.valueDate}</Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 185, minWidth: 185 }]}> {item.transId} </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={[styles.rowStyle, { width: 180, minWidth: 180 }]}>{item.activity + (item.tollPlazaName ? '-' + item.tollPlazaName : '')}</Text>
                          <View style={styles.verticalLineStyle} />
                                  {appliedStatementType === "CONSOLIDATED" ? (
                            <>
                              <Text style={styles.rowStyle}>
                                {item.debitTag != null ? parseFloat(item.debitTag).toFixed(2) : "-"}
                              </Text>
                              <View style={styles.verticalLineStyle} />

                              <Text style={styles.rowStyle}>
                                {item.creditTag != null ? parseFloat(item.creditTag).toFixed(2) : "-"}
                              </Text>
                              <View style={styles.verticalLineStyle} />

                              <Text style={styles.rowStyle}>
                                {item.debitPool != null ? parseFloat(item.debitPool).toFixed(2) : "-"}
                              </Text>
                              <View style={styles.verticalLineStyle} />

                              <Text style={styles.rowStyle}>
                                {item.creditPool != null ? parseFloat(item.creditPool).toFixed(2) : "-"}
                              </Text>

                            <View style={styles.verticalLineStyle} />
                            <Text style={styles.rowStyle}>{!isNaN(parseFloat(tagClosingBal)) ? parseFloat(tagClosingBal).toFixed(2) : "-"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={styles.rowStyle}>{!isNaN(parseFloat(poolClosingBal)) ? parseFloat(poolClosingBal).toFixed(2) : "-"}</Text>
                          </>
                        ) : (
                          <>
                            <Text style={styles.rowStyle}>{!isNaN(parseFloat(debit)) ? parseFloat(debit).toFixed(2) : "-"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={[styles.rowStyle, { width: 100 }]}>{!isNaN(parseFloat(credit)) ? parseFloat(credit).toFixed(2) : "-"}</Text>
                            <View style={styles.verticalLineStyle} />
                            <Text style={[styles.rowStyle, { width: 120, color: "#54c414" }]}>{balance.toFixed(2)}</Text>
                          </>
                        )}
                        </View>
                      );
                    }}
                  />
                              
                </View>
                {/* {alertModalVisible && (<View style={styles.overlayViewStyleAlert}> */}
                  {/* <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} /> */}
                {/* </View>) */}
                {/* }  */}
                {loading && <Loader />}
              
              </ScrollView>
              </View>) :
              
              (
                <View style={styles.nodataViewStyle}>
                  <View style={{ alignItems: "center", marginVertical: 80 }}>
                    <CImage.iconNoResultBg />
                    <Text style={styles.titleNoResult}>No Data Found</Text>
                    <Text style={styles.descNoResult}></Text>
                  </View>
                  {loading && <Loader />}
                </View>)}
                

            {statementVrnData.getVrnStatement?.length > 0 && (
              <View style={{ marginTop: 20 }}>
                <ReactPaginate
                  nextLabel="next >"
                  onPageChange={(e) => { onClickPagination(e.selected); }}
                  pageRangeDisplayed={2} marginPagesDisplayed={1}
                  pageCount={pageNumbers} previousLabel="< previous"
                  pageClassName="page-item" pageLinkClassName="page-link"
                  previousClassName="page-item" previousLinkClassName="page-link"
                  nextClassName="page-item" nextLinkClassName="page-link"
                  breakLabel="..." breakClassName="page-item"
                  breakLinkClassName="page-link" containerClassName="pagination" activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </View>
            )}
            {filterModalVisible ? (<View style={styles.overlayViewStyleFilter}>
              <View style={styles.overlayContainer}>
                <View style={styles.overlay}>
                  <View style={styles.modalHeader}>
                    <View style={styles.filterTitle}>
                      <TouchableOpacity onPress={() => { setFilterModalVisible(false); }} >
                        <View style={styles.circle23}>
                          <Text style={styles.circleText}>x</Text>
                        </View>
                      </TouchableOpacity>
                      <Text style={styles.filterText}>Filter</Text>
                    </View>
                    <TouchableOpacity onPress={onFilterClear}>
                      <Text style={styles.filterText}>Clear</Text>
                    </TouchableOpacity>
                  </View>
                  <View style={styles.filterRadioWidget}>

                    <View style={styles.statementTypeWidget}>
                      <Text style={[styles.filterText, { marginBottom: 20 }]}> Period of Statement</Text>
                      <RadioButton IsStatementFilter = {true} PROP={PERIOD_STATEMENT_TYPE} orientation={"column"} dir={"column"} selectedValue={periodStatementType} redBg={true}
                        onSelect={(value) => {
                          periodSetSelectStatementType(value.key);
                          setPeriod(value.val);
                        }} />
                    </View>
                  </View>
                  <View style={styles.footerWidget}>
                    {/* <View style={styles.transactionAmountWidget}>
                      <Text style={[styles.filterText, { marginBottom: 10 }]}  >Transaction Amount </Text>
                      <Text style={styles.minAmountText} > {minAmount} - {maxAmount} </Text>
                      <RangeSlider
                        // range={[0, 100]}
                        range = {[minAmount,maxAmount]}
                        minimumValue={0}
                        maximumValue={1000000}
                        step={1}
                        minimumRange={1}
                        crossingAllowed={false} // If true, the user can make one thumb cross over the second thumb
                        outboundColor="#f1f2f4"
                        inboundColor="#9b1e26"
                        thumbTintColor="#fff" // The color of the slider's thumb
                        thumbStyle={undefined}
                        trackStyle={undefined}
                        minTrackStyle={undefined} // Override the tracks' style for the minimum range
                        midTrackStyle={undefined}
                        maxTrackStyle={undefined} // Override the tracks' style for the maximum range
                        vertical={false}
                        inverted={false}
                        enabled={true}
                        trackHeight={4} // The track's height in pixel
                        thumbSize={15}
                        thumbImage={undefined}
                        slideOnTap={true} // If true, touching the slider will update it's value. No need to slide the thumb.
                        onValueChange={() => { }} // Called each time the value changed. The type is (range: [number, number]) => void
                        onSlidingStart={undefined} // Called when the slider is pressed. The type is (range: [number, number]) => void
                        onSlidingComplete={handleValueChange} // Called when the press is released. The type is (range: [number, number]) => void
                        {...props} // Add any View Props that will be applied to the container (style, ref, etc)
                      />
                    </View> */}
                    <CView FR JC W100>
                      <CustomButton onPress={() => filter("0")} text={"Apply"} disable={false} style={[styles.btnBorderStyle, { minWidth: 150 }]} />
                    </CView>
                  </View>
                </View>
              </View>
            </View>
            ) : null}

            {alertModalVisible && (<View style={styles.overlayViewStyleAlert}>
              <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
            </View>)}
            
            {isGenerating && <Loader/>}   
            <StatementAlert
                open={showAlert}
                onClose={() => setShowAlert(false)}
                onConfirm={(email)=>{handleConfirmEmail(email);setShowAlert(false);}}
            />
            <StatementNoPreviewAlert
              open={showAlertNoPreview}
              onClose={() => setShowAlertNoPreview(false)}
              onEmail={() => {
                setShowAlert(true);
                setShowAlertNoPreview(false);
              }}
              onDownload={() =>{ onDownloadStatementAction("Download");
                setShowAlertNoPreview(false);}}
            />
          </View>
        </View>
      </View>
    </View>
  );
};
export default Statement;

